<app-survey *ngIf="surveyMetaId" [surveyMetaId]="surveyMetaId" [learningPathId]="learningPathId" [learningTourId]="learningTourId"></app-survey>


// WEBPACK FOOTER //
// ./src/app/character.component.html